import $ from 'jquery';
import * as service from './service';
import * as report from './dataReport';
import { commonUpload } from './dataReport';
let seconds = 0; // 计时器
export const loading = () => {
  let progressNum = 0;
  let count = 0;
  const timeArr = [];
  const $textArr = $('.j-world-text p');
  const $loadingMan = $('.j-loading-man');
  const $loadingText = $('.j-loading-text');
  const $loadingProgress = $('.j-progress-bar-full');
  $textArr.each((index, ele) => {
    const timer = setTimeout(() => {
      $(ele).addClass('active');
    }, 2000 * index);
    timeArr.push(timer);
  });
  const progress = setInterval(() => {
    seconds++;
    if (progressNum === 99 && count++ > 30) {
      showPage();
      return;
    }
    progressNum < 99 && progressNum++;
    $loadingText.text(progressNum + '%');
    $loadingProgress.css('width', progressNum + 1 + '%');
    $loadingMan.css('left', progressNum - 3 + '%');
  }, 200);
  const showPage = () => {
    commonUpload('view_page', '加载页-' + ~~(seconds * 0.2));
    report.setTimeCounter(); // 开始首页曝光计时
    timeArr.forEach(item => {
      clearTimeout(item);
    });
    clearInterval(progress);
    $loadingText.text('100%');
    $loadingProgress.css('width', '100%');
    $loadingMan.css('left', '100%');
    $('.j-section1-content,.right,.sns,.download-wrap').addClass('active');
    $('.j-loading').fadeOut(1000);
    if (!window.platform.isPhone()) {
      $('#j-video-in')[0].play();
    }
    $('body').one('click', function () {
      $('.j-music-audio')[0].play();
    });
  };
  const videoControl = () => {
    $('#j-video-in')[0].addEventListener(
      'ended',
      function () {
        $('#j-video-in').hide();
        $('#j-video-loop').show();
      },
      false
    );
  };
  window.addEventListener('load', () => {
    showPage();
    window.platform.isPhone() ? $('#j-video-loop').show().get(0).play() : videoControl();
    service.init();
  });
};
